import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { formatAuthor } from '../../composants/utils/utils';

const Testimonials = ({testimonials}) => {
  return (
    <>
        {testimonials.length != 0 &&     <div className="py-16">
            <Swiper
            modules={[Autoplay, Navigation, Pagination]}
            spaceBetween={30}
            centeredSlides={true}
            loop={true}
            autoplay={{
                delay: 5000,
                disableOnInteraction: false,
            }}
            pagination={{
                clickable: true
            }}
            className="max-w-3xl mx-auto px-4"
            >
            {testimonials.map((testimonial) => (
                <SwiperSlide key={testimonial.id}>
                <div className="text-center">
                    <blockquote title={testimonial.contenu} className="text-black text-xl leading-relaxed mb-8 px-4">
                    "{formatAuthor(testimonial.contenu,55)}"
                    </blockquote>
                    
                    <div className="relative">
                    <div className="w-24 h-24 mx-auto mb-4 rounded-full border-4 border-purple-500 overflow-hidden">
                        <FontAwesomeIcon icon={faUser} className="w-full h-full object-cover"/>
                    </div>
                    <h3 className="text-black font-bold text-lg mb-2">{testimonial.author}</h3>
                    <p title={testimonial.title} className="text-gray-400 text-sm">{formatAuthor(testimonial.title, 12)}</p>
                    </div>
                </div>
                </SwiperSlide>
            ))}
            </Swiper>
        </div>
        }
    </>

  );
};

export default Testimonials;